export const ZendeskTicketFormFields = {
	Comment: {
		name: "comment",
		displayName: "Comment",
	},
	Reason: {
		name: "reason",
		displayName: "Reason Codes",
	},
	Subject: {
		name: "subject",
		displayName: "Subject",
	},
};
